import { OpsType } from '@weave/schema-gen-ts/dist/shared/organization/ops_type.pb';
import { useQuery } from 'react-query';
import { PaymentsClient } from '@frontend/api-payments';
import { getInterScreenQueryOptions } from '@frontend/payments-hooks';
import { useStripePromise } from '@frontend/payments-stripe-wrapper';
import { getPaymentsPlatformQueryKey } from '../../utils/query-key';

export type UseLoadStripeKeyProps = {
  locationId: string;
  isPublic: boolean;
  opsType: OpsType | undefined;
};

const getStripeKeyPublic = (_locationId: string) => {
  console.warn('TODO: getStripeKeyPublic needs actual implementation, or to be removed');

  return Promise.resolve(Math.round(Math.random()) === 1 ? '' : undefined);
};

export const getUseLoadStripeKeyQueryKey = (locationId: string, isPublic: boolean, ...xs: any[]) =>
  getPaymentsPlatformQueryKey('stripe-key', locationId, isPublic, ...xs);

export const useLoadStripeKey = ({ locationId, isPublic, opsType }: UseLoadStripeKeyProps) => {
  const { data: stripeExpressKey } = useQuery({
    queryKey: getUseLoadStripeKeyQueryKey(locationId, isPublic),
    queryFn: () => (!isPublic ? PaymentsClient.getStripeExpressPublicKey(opsType!) : getStripeKeyPublic(locationId)),
    enabled: !!locationId && !!opsType,
    ...getInterScreenQueryOptions(),
  });
  return useStripePromise({ stripeExpressKey });
};
